import React, { useState } from "react";
import { RotateCcw, X } from "lucide-react";
// Default avatar: curly-hair model photo (Unsplash, photo HTgvpzZ5bv4 by Kamyar Ghalamchi)
import defaultHairCareAvatar from "../../assets/images/haircare-model.jpg";

// Circular avatar with a border; cover + position keeps the face centred in the circle
const headerAvatarStyle = {
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  objectFit: "cover",
  objectPosition: "50% 25%",
  border: "2px solid var(--color-headerbartext)",
  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)",
  flexShrink: 0,
};

const ChatBotHeader = ({ imageurl, title, showExtraContent, toggleExtraContent, onRefresh }) => {

  return (
    <header
      className="krunk-flex krunk-justify-between krunk-items-center krunk-gap-0 sm:krunk-rounded-t-xl krunk-px-4 krunk-py-3 krunk-shadow-md krunk-relative krunk-z-10"
      style={{ background: "var(--color-headerbar)", color: "var(--color-headerbartext)" }}
    >
      <div className="krunk-flex krunk-items-center krunk-gap-2 krunk-w-full">
        <img
          src={imageurl || defaultHairCareAvatar}
          alt={title || "Hair care assistant"}
          style={headerAvatarStyle}
        />
        <div className="krunk-w-full">
          <div className="krunk-flex krunk-items-center krunk-gap-3 krunk-justify-between">
            <h1 className="krunk-text-lg krunk-font-semibold krunk-leading-7">
              {title}
            </h1>
            
            {/* Action Buttons Container */}
            <div className="krunk-flex krunk-items-center krunk-gap-2">
              {/* Refresh Button */}
              <button
                onClick={onRefresh}
                className="hover:krunk-opacity-70 krunk-transition-opacity krunk-duration-200"
                title="Refresh Chat"
              >
                <RotateCcw className="krunk-w-5 krunk-h-5" />
              </button>
              
              {/* Cross Button */}
              <button
                onClick={toggleExtraContent}
                className="hover:krunk-opacity-70 krunk-transition-opacity krunk-duration-200"
                title="Close Chat"
              >
                <X className="krunk-w-5 krunk-h-5" />
              </button>
            </div>
          </div>
          <div className="krunk-flex krunk-items-center krunk-justify-between krunk-w-full">
            <div className="krunk-flex krunk-items-center krunk-gap-1"></div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ChatBotHeader;